import React, { useState } from "react";
import { Drawer } from "antd5";

import Button from "components/ui/button/Button";
import { TrackingProvider } from "lib/tracking";
import { Flex, Text } from "../../../styles/utility-components";
import { SaveToLists } from "./lists/SaveToLists";
import { EntityType } from "./types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  noticeGuid: string;
};

const ENTITY_TYPE_NOTICE: EntityType = "notice";

export function DropdownSaveNoticeDrawer({ isOpen, onClose, noticeGuid }: Props) {
  const [creation, setCreation] = useState(false);

  return (
    <Drawer
      placement="right"
      closable={true}
      open={isOpen}
      width={486}
      onClose={onClose}
      styles={{
        header: { display: "none" },
        body: { padding: "24px" },
      }}
      onClick={(event) => {
        // Prevent the drawer from propagating click events to the parent e.g. row click
        event.stopPropagation();
      }}
    >
      <TrackingProvider data={{ "Data type": ENTITY_TYPE_NOTICE.toUpperCase() }}>
        <Flex gap={32} height="100%" aria-label="Save this notice to a list">
          <Flex column height="100%" gap={24} width="440px">
            <Flex justifyContent="space-between" alignItems="flex-start">
              {creation ? (
                <Button
                  as="button"
                  buttonType="secondary"
                  buttonStyle="default"
                  icon="arrowNarrowLeft"
                  onClick={() => setCreation(false)}
                />
              ) : (
                <Text h3>Save to a list</Text>
              )}
              <Button
                as="button"
                buttonType="secondary"
                buttonStyle="default"
                icon="xClose"
                onClick={onClose}
              />
            </Flex>
            <Flex column height="calc(100% - 48px)" gap={24}>
              <Flex column height="100%">
                <SaveToLists
                  entityType={ENTITY_TYPE_NOTICE}
                  entityIds={[noticeGuid]}
                  creation={creation}
                  setCreation={setCreation}
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </TrackingProvider>
    </Drawer>
  );
}
